export default {"src":"/_next/static/media/Twitter.659643a5.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};